// extracted by mini-css-extract-plugin
export default {"container":"styles_container__p6vxI","label":"styles_label__3AW0L","loader":"styles_loader__0sBS7","spin":"styles_spin__r1YCn"};